import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useBuyInvoiceHeaderURLs = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/buy/buyInvoice/orderCost/createBuyInvoiceCost',
        updateCost: '/api/app/order/buy/buyInvoice/orderCost/updateBuyInvoiceCost',
        deleteCost: '/api/app/order/buy/buyInvoice/orderCost/deleteBuyInvoiceCost',
        createFinancialRow: '/api/app/order/buy/buyInvoice/orderFinancialRow/createBuyInvoiceFinancialRow',
        updateFinancialRow: '/api/app/order/buy/buyInvoice/orderFinancialRow/updateBuyInvoiceFinancialRow',
        deleteFinancialRow: '/api/app/order/buy/buyInvoice/orderFinancialRow/deleteBuyInvoiceFinancialRow',
        createAccount: '/api/app/order/buy/buyInvoice/orderAccount/createBuyInvoiceAccount',
        updateAccount: '/api/app/order/buy/buyInvoice/orderAccount/updateBuyInvoiceAccount',
        deleteAccount: '/api/app/order/buy/buyInvoice/orderAccount/deleteBuyInvoiceAccount',
        createShipping: '/api/app/order/buy/shipping/createBuyShippingForInvoice',
        updateShipping: '/api/app/order/buy/shipping/updateBuyShippingInvoice',
        createVariable: '/api/app/order/buy/buyInvoice/orderVariable/createBuyInvoiceVariable',
        updateVariable: '/api/app/order/buy/buyInvoice/orderVariable/updateBuyInvoiceVariable',
        deleteVariable: '/api/app/order/buy/buyInvoice/orderVariable/deleteBuyInvoiceVariable',
        updateWorkingCenter: '/api/app/order/buy/buyInvoice/updateBuyInvoiceWorkingCenter',
        createUpdateProductTypes: '/api/app/order/buy/buyInvoice/orderProductType/createUpdateBuyInvoiceProductTypes',
    }
    return orderHeaderURLs
}

export default useBuyInvoiceHeaderURLs